<template>
  <Dialog v-model="visible" :title="title" show-close>
    <div class="act-time-dialog" :class="isMobile ? 'mobile' : 'pc'">
      <ActCountDown
        v-if="props.phase === 'not-start'"
        class="countdown"
        :server-ms="props.serverMs"
        :start-ms="props.startMs"
        :end-ms="0"
      />
      <div class="act-time-text" v-else>{{ $t('novShopping.status.ended') }}</div>
    </div>
  </Dialog>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'
import { isMobile } from '@/utils'
import Dialog from '../Dialog/index.vue'
import ActCountDown from '../ActCountDown/index.vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  // not-start | ended
  phase: {
    type: String,
    default: 'not-start',
  },
  serverMs: {
    type: Number,
    default: 0,
  },
  startMs: {
    type: Number,
    default: 0,
  },
})

const emit = defineEmits(['update:modelValue'])

const { t } = useI18n()

const visible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

const title = computed(() => (
  props.phase === 'not-start' ? t('novShopping.status.notStart') : t('novShopping.status.ended')
))
</script>

<style lang="less" scoped>
.act-time-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 0 20px;

  .act-time-text {
    font-size: 28px;
    color: #4a3f2f;
    padding: 20px 0;
  }
}
</style>

<style lang="less" scoped src="./mobile_style.less"></style>
